import LongText from '../Elements/LongText';
import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';

export default class CommissionLineDetailItem {
  constructor(item) {
    if (item === undefined) {
      this.CommissionLineId = null;
      this.ServiceId = null;
      this.ServiceOpportunityId = null;
      this.CurrencyId = null;
      this.CurrencyCode = null;
      this.CommissionValue = null;
      this.CommissionedEntityId = null;
      this.CommissionedEntityName = null;
      this.RevenuePeriod = null;
      this.SourceId = null;
      this.SourceType = null;
      this.SourcePaidOnUtc = null;
      this.Comments = null;
      return;
    }
    this.CommissionLineId = item.commissionLineId;
    this.ServiceId = item.serviceId;
    this.ServiceOpportunityId = item.serviceOpportunityId;
    this.CurrencyId = item.currencyId;
    this.CurrencyCode = item.currencyCode;
    this.CommissionValue = item.commissionValue;
    this.CommissionedEntityId = item.commissionedUserId ? item.commissionedUserId : item.commissionedEntityId;
    this.CommissionedEntityName = item.commissionedUserId
      ? `${item.commissionedUserLastName}, ${item.commissionedUserFirstName} (${item.commissionedUserId})`
      : `${item.commissionedExternalSalesPartnerName} (${item.commissionedExternalSalesPartnerId})`;
    this.RevenuePeriod = item.revenuePeriod;
    this.Source = item.sourceType === 'Manual' ? 'Manual' : `${item.sourceId} (${item.sourceType})`;
    this.SourceId = item.sourceId;
    this.SourceType = item.sourceType;
    this.SourcePaidOnUtc = item.sourcePaidOnUtc;
    this.Comments = item.comments;
  }

  static MoneyFields = ['CommissionValue'];

  static Currency() {
    return 'CurrencyCode';
  }

  static DateFields = ['SourcePaidOnUtc'];

  static BoolFields = [];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Name (ID)', orderById: 'CommissionedEntityName', data: 'CommissionedEntityName' },
      { label: 'Opportunity ID', orderById: 'ServiceOpportunityId', data: 'ServiceOpportunityId' },
      { label: 'Service ID', orderById: 'ServiceId', data: 'ServiceId' },
      { label: 'Source ID (IN/CM)', orderById: 'Source', data: 'Source' },
      { label: 'Revenue Period', orderById: 'RevenuePeriod', data: 'RevenuePeriod' },
      { label: 'Currency', orderById: 'CurrencyCode', data: 'CurrencyCode' },
      { label: 'Commission Amount', orderById: 'CommissionValue', data: 'CommissionValue' },
      { label: 'Source Paid On', orderById: 'SourcePaidOnUtc', data: 'SourcePaidOnUtc' },
      {
        label: 'Comments',
        orderById: 'Comments',
        data: (item) => (
          <LongText
            text={item.Comments ? item.Comments : ' '}
            maxLength={50}
          />
        ),
      },
      {
        label: ' ',
        orderById: '',
        data: CommissionLineDetailItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Edit',
            iconName: 'fa-solid fa-edit',
            onClick: () => CommissionLineDetailItem.editFunction(item.CommissionLineId, item),
            disabled: item.SourceType !== 'Manual',
          },
          {
            text: 'Remove',
            iconName: 'fa-solid fa-trash-can',
            onClick: () => CommissionLineDetailItem.removeFunction(item.CommissionLineId, item),
            disabled: item.SourceType !== 'Manual',
          },
        ]}
      />
    );
  }

  static editFunction(id, item) {
    alert('Empty function!');
  }
  static removeFunction(id, item) {
    alert('Empty function!');
  }
}
